'use client'

import VaultConfigurationLoading from './VaultConfigurationLoading'

/** Mirrors `VaultConfigurationLayout`, title included. */
const VaultConfigurationSectionLoading = () => {
  return (
    <div className="gap-sm flex flex-col">
      <span className="text-foreground text-sm">Vault Configuration</span>
      <VaultConfigurationLoading />
    </div>
  )
}

export default VaultConfigurationSectionLoading
